'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExercisesListItem = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ExercisesListItem, _Component);

  function ExercisesListItem() {
    (0, _classCallCheck3.default)(this, ExercisesListItem);
    return (0, _possibleConstructorReturn3.default)(this, (ExercisesListItem.__proto__ || (0, _getPrototypeOf2.default)(ExercisesListItem)).apply(this, arguments));
  }

  (0, _createClass3.default)(ExercisesListItem, [{
    key: 'render',
    value: function render() {
      var styles = require('./ExercisesListItem.scss');
      var _props = this.props,
          commonProps = _props.commonProps,
          dragHandle = _props.dragHandle,
          item = _props.item,
          itemSelected = _props.itemSelected;

      var dragged = itemSelected > 0.75;
      var selected = item.index === commonProps.selectedExerciseIndex;

      return _react2.default.createElement(
        'div',
        { className: styles.exercisesListItem + (selected ? ' active' : '') + (dragged ? ' dragged' : ''), onClick: item.onClick.bind(null, item.index) },
        dragHandle(_react2.default.createElement('div', { className: styles.dragHandle })),
        _react2.default.createElement(
          'div',
          { className: styles.exercisesListItemTitle },
          'Exercice ',
          item.index + 1
        ),
        _react2.default.createElement(
          'div',
          { className: styles.exercisesListItemCount },
          item.questionsCount,
          ' questions'
        ),
        _react2.default.createElement(
          'div',
          { className: styles.execisesListItemDifficulty },
          _react2.default.createElement(
            'p',
            null,
            '\uD83D\uDCAA ',
            item.difficultyLevel,
            ' / 3'
          ),
          _react2.default.createElement(
            'p',
            null,
            '\u23F1\uFE0F ',
            item.duration / 60,
            ' min'
          ),
          item.isEssential && _react2.default.createElement(
            'p',
            null,
            '\u2B50'
          )
        )
      );
    }
  }]);
  return ExercisesListItem;
}(_react.Component), _class.propTypes = {
  commonProps: _react.PropTypes.object.isRequired,
  dragHandle: _react.PropTypes.func.isRequired,
  item: _react.PropTypes.object.isRequired,
  itemSelected: _react.PropTypes.number.isRequired
}, _temp);
exports.default = ExercisesListItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ExercisesListItem/ExercisesListItem.js
// module id = 1160
// module chunks = 0